__turbopack_context__.v({
  "chapterArrow": "adk7MG_chapterArrow",
  "chapterInfo": "adk7MG_chapterInfo",
  "chapterListItem": "adk7MG_chapterListItem",
  "chapterName": "adk7MG_chapterName",
  "chapterNumber": "adk7MG_chapterNumber",
  "chapterPanelCount": "adk7MG_chapterPanelCount",
  "chapterRatingPill": "adk7MG_chapterRatingPill",
  "chapterSection": "adk7MG_chapterSection",
  "chapterSectionTitle": "adk7MG_chapterSectionTitle",
  "chapterThumb": "adk7MG_chapterThumb",
  "chapterThumbBadge": "adk7MG_chapterThumbBadge",
  "chapterThumbBlurred": "adk7MG_chapterThumbBlurred",
  "chapterThumbEmpty": "adk7MG_chapterThumbEmpty",
  "ctaBtn": "adk7MG_ctaBtn",
  "dashboardHeader": "adk7MG_dashboardHeader",
  "dashboardNewBtn": "adk7MG_dashboardNewBtn",
  "loadMore": "adk7MG_loadMore",
  "loadMoreBtn": "adk7MG_loadMoreBtn",
  "loadingCenter": "adk7MG_loadingCenter",
  "notFound": "adk7MG_notFound",
  "notFoundLink": "adk7MG_notFoundLink",
  "overviewBackBtn": "adk7MG_overviewBackBtn",
  "overviewContent": "adk7MG_overviewContent",
  "overviewCreator": "adk7MG_overviewCreator",
  "overviewCreatorAvatar": "adk7MG_overviewCreatorAvatar",
  "overviewCreatorRow": "adk7MG_overviewCreatorRow",
  "overviewDescription": "adk7MG_overviewDescription",
  "overviewHero": "adk7MG_overviewHero",
  "overviewHeroEmpty": "adk7MG_overviewHeroEmpty",
  "overviewHeroGradient": "adk7MG_overviewHeroGradient",
  "overviewHeroImage": "adk7MG_overviewHeroImage",
  "overviewMeta": "adk7MG_overviewMeta",
  "overviewRoot": "adk7MG_overviewRoot",
  "overviewStatDot": "adk7MG_overviewStatDot",
  "overviewStatPill": "adk7MG_overviewStatPill",
  "overviewStats": "adk7MG_overviewStats",
  "overviewTitle": "adk7MG_overviewTitle",
  "readerBottomNav": "adk7MG_readerBottomNav",
  "readerChapterNav": "adk7MG_readerChapterNav",
  "readerCreator": "adk7MG_readerCreator",
  "readerEmpty": "adk7MG_readerEmpty",
  "readerHeader": "adk7MG_readerHeader",
  "readerHeaderInner": "adk7MG_readerHeaderInner",
  "readerHeaderLeft": "adk7MG_readerHeaderLeft",
  "readerNavBtn": "adk7MG_readerNavBtn",
  "readerPagesSpread": "adk7MG_readerPagesSpread",
  "readerPanel": "adk7MG_readerPanel",
  "readerPanelBlurWrap": "adk7MG_readerPanelBlurWrap",
  "readerPanels": "adk7MG_readerPanels",
  "readerRoot": "adk7MG_readerRoot",
  "readerTitle": "adk7MG_readerTitle",
  "readerTitleGroup": "adk7MG_readerTitleGroup",
  "spin": "adk7MG_spin",
  "spinner": "adk7MG_spinner",
});
